const crypto = require("crypto");
import moment from "moment";
export default {
  // mounted() {
  //   console.log("+++ mixin mounted");
  //   const self = this;
  //   this.$nextTick(function () {
  //     if (!self.currentUser && this.$route.path != "/path") {
  //       self.$router.push("/login");
  //     }
  //   });
  // },
  computed: {
    currentUser() {
      // console.log("+++ mixin currentUser");
      return this.$store.state.auth.user;
    },
  },
  methods: {
    commentDate(createdAt) {
      const date = moment(createdAt).format("YYYY/MM/DD");
      const today = moment().format("YYYY/MM/DD");
      // console.log("commentDate");
      // console.log(createdAt);
      // console.log(date);
      // console.log(today);
      if (date == today) {
        return "";
      } else {
        return moment(createdAt).format("MM/DD");
      }
    },
    commentTime(createdAt) {
      return moment(createdAt).format("HH:mm");
    },
    isPermission(value) {
      return this.$store.getters["auth/isPermission"](value);
    },
    isOfficialWord(value) {
      return value ? "" : "予定";
    },
    md5hex(str /*: string */) {
      const md5 = crypto.createHash("md5");
      return md5.update(str, "binary").digest("hex");
    },
    createTag(tag) {
      const titles = {
        tag01: "作業予定",
        tag02: "重要",
        tag03: "書類",
        tag04: "理事会",
      };
      return `<span class="tag ${tag}">${titles[tag]}</span>`;
    },
    toYYYYMMDD(str) {
      // console.log("+++ toYYYYMMDD");
      if (str != undefined) {
        return moment(str).format("YYYY/MM/DD");
      } else {
        return "";
      }
    },

    toTIMESTAMP(str, hhmm) {
      // console.log("+++ toYYYYMMDD");
      if (str != undefined) {
        return moment(str).format("YYYY/MM/DD") + ` ${hhmm}`;
      } else {
        return "";
      }
    },
    currentDate() {
      return moment().format("YYYY/MM/DD HH:mm");
    },
  },
};
